var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('JqueryTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }